/**
 * iconName -> string =  nome do icon
 * title -> string = titulo
 * content -> string = conteudo
 * iconWidth -> string = largura do icone
 * iconHeight -> string = largura do icone
 * iconMargin -> string = margem do icone
 * link -> string = página interna a ser direcionado
 * textLink -> 
 */
import React from "react";
import { Link } from "react-router-dom";
import './CardInfoIcon.css'
import getImage from "../../useFull/getImage";

const CardInfoIcon = props => {
    const { iconName, title, content, iconWidth, iconHeight, iconMargin, link, afterLink, textLink} = props

    const img = getImage('card-info', iconName);

    return (
        <div className="container-card-structure-btu w-box-shadow" >
            <div style={{
                backgroundImage: `url(${img})`,
                width: iconWidth || '40px',
                height: iconHeight || '40px',
                margin: iconMargin || 0
            }} className='bg-icon' />
            <span className='text-title-secondary'>{title}</span>
            <span >{content}{link ? <><Link to={link} className="link-card">{textLink}</Link> {afterLink}</>: ''}</span>
        </div>
    )
}

export default CardInfoIcon